import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  FlightNextDay: {
    currency: '',
    price_per_person: ''
  },
  Rebook: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
